export default __webpack_public_path__ + "static/media/mobile.2cc06fd4.svg";